import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ArrowUpRight, InfoIcon } from 'lucide-react';
import { easeOutStrong } from '../../utils/motion';
import { demoUrlFor } from '../../data/demoCenter';
export function ResearchIntro() {
  return <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-44 lg:pb-24" data-id="element-1925" data-mp="39yc00mwft16t">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: easeOutStrong
    }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1926" data-mp="3ethj7dygg1r7">
        <div className="lg:col-span-5" data-id="element-1927" data-mp="2r6swmeyi3l49">
          <p className="text-sm font-medium text-teal mb-5" data-id="element-1928" data-mp="2r3nan8l64zcr">Research</p>
          <h1 className="font-heading font-extrabold text-5xl lg:text-6xl text-ink-dark leading-[1.05] tracking-tight" data-id="element-1929" data-mp="2w5cjqiotz2y7">
            Two connected questions
          </h1>
        </div>
        <div className="lg:col-span-7 lg:pt-10" data-id="element-1930" data-mp="2m5lp8h09sny4">
          <p className="text-2xl text-ink-dark leading-relaxed mb-6" data-id="element-1931" data-mp="2m8hqae7ezsqs">
            SyNeural’s research begins with two connected questions: How do
            people develop sound judgment? And how can knowledge systems help
            researchers and institutions think more clearly?
          </p>
          <p className="text-lg text-ink-muted leading-relaxed mb-8" data-id="element-1932" data-mp="c6wk7atj28nw">
            Our work brings together cognitive science, human development,
            semantic knowledge, institutional design, and responsible AI. The
            Semantic Knowledge Platform (SKP) connects ideas across research and
            policy. The Human Capability Framework, including CJI and NCJI,
            explores how judgment can be understood, developed, and reassessed
            over time.
          </p>
          <p className="text-lg text-ink-muted leading-relaxed mb-8" data-id="element-1933" data-mp="3kn7v0gqynoa8">
            This page describes SyNeural’s research agenda. It is separate from
            the Noetivra Research product demo, which shows how a research team
            could trace fictional findings to their sources and review proposed
            relationships.
          </p>
          <div className="flex gap-4 bg-surface-muted rounded-lg p-5 mb-8" data-id="element-1934" data-mp="10va8t7yyt676">
            <InfoIcon size={20} className="text-navy-light shrink-0 mt-0.5" aria-hidden="true" data-id="element-1935" data-mp="15miim547itkv" />
            <p className="text-ink-dark leading-relaxed" data-id="element-1936" data-mp="1amoddu5rww76">
              These are active areas of research and product development.
              Concepts described here may require further testing, validation,
              and institutional review before they are suitable for
              consequential use.
            </p>
          </div>
          <div className="flex flex-wrap gap-x-8 gap-y-3" data-id="element-1937" data-mp="muzhk3tqtplh">
            <a href="/roadmap" className="inline-flex items-center gap-2 text-navy font-semibold hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1938" data-mp="rw6q453pmst7">
              See where our research is going
              <ArrowRight size={16} aria-hidden="true" data-id="element-1939" data-mp="23cwxhrjvdqoe" />
            </a>
            <a href={demoUrlFor('research')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-navy font-semibold hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1940" data-mp="3nsbipvtios1n">
              Open Research Demo
              <ArrowUpRight size={16} aria-hidden="true" data-id="element-1941" data-mp="3924a07tbane5" />
              <span className="sr-only" data-id="element-1942" data-mp="345na6gcr2kl8">(opens in a new tab)</span>
            </a>
          </div>
        </div>
      </motion.div>
    </section>;
}